import { Link } from 'react-router-dom'

export default function BlogCard({ post }) {
  return (
    <Link
      to={`/blog/${post.slug}`}
      style={{
        border: '1px solid var(--stone-mid)',
        borderRadius: 'var(--radius-lg)',
        overflow: 'hidden',
        background: 'var(--white)',
        display: 'block',
        textDecoration: 'none',
        color: 'inherit',
        transition: 'var(--transition)',
      }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = 'var(--shadow-md)' }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none' }}
    >
      <div style={{ height: '140px', background: 'var(--stone)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '48px', position: 'relative' }}>
        {post.emoji}
        <span style={{ position: 'absolute', top: '12px', left: '12px', fontSize: '10px', letterSpacing: '1px', textTransform: 'uppercase', background: 'var(--white)', color: 'var(--green-dark)', padding: '3px 10px', borderRadius: '40px', fontWeight: 500 }}>
          {post.category}
        </span>
      </div>
      <div style={{ padding: '18px' }}>
        <h3 style={{ fontFamily: 'var(--serif)', fontSize: '18px', fontWeight: 600, lineHeight: 1.3, marginBottom: '8px' }}>
          {post.title}
        </h3>
        <p style={{ fontSize: '13px', color: 'var(--ink-mid)', lineHeight: 1.6, marginBottom: '12px', fontWeight: 300 }}>
          {post.excerpt}
        </p>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: 'var(--ink-light)' }}>
          <span>{post.date}</span>
          <span style={{ color: 'var(--green)', fontWeight: 500 }}>{post.readTime} →</span>
        </div>
      </div>
    </Link>
  )
}
